import React from 'react';

// Styles & Assets
import styles from './DeviceStatus.module.css';
import { MdDelete } from 'react-icons/md';

// Services
import { isDeviceOnLoan } from '../../../services/DevicesHelpers';
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useState } from 'react';
import useHttp from '../../../hooks/useHttp';

// Components
import Modal from '../../UI/Modal/Modal';

// Interfaces
import { Device } from '../../../interfaces/Device';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

// Language
import { useTranslation } from 'react-i18next';

const DeviceStatus: React.FC<{
    device: Device
    deleteDeviceCallback: (deviceID: number) => void
}> = ({ device, deleteDeviceCallback }) => {

    const { t } = useTranslation();

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const { sendRequest: deleteDevice } = useHttp();

    const handleDeleteDevice = () => {
        const deviceID = device.id;
        if (deviceID === undefined) return;
        deleteDevice({
            url: getEnvironmentApiUrl() + 'device/' + deviceID + '/logic',
            method: 'DELETE',
        }, () => deleteDeviceCallback(deviceID));
        setShowDeleteDialog(false);
    };

    return (
        <>
            <div className={styles.statusContainer}>
                {!isDeviceOnLoan(device) ?
                    <button className={styles.left} onClick={() => setShowDeleteDialog(true)}>
                        <MdDelete />
                    </button>
                    : <div className={styles.left}></div>
                }
                <div className='centerContainer'>
                    <div className={isDeviceOnLoan(device) ?
                        'smallCircle inactiveCircle' : 'smallCircle activeCircle'}></div>
                </div>
            </div>
            <Modal
                show={showDeleteDialog}
                setShowModal={setShowDeleteDialog}
            >
                <div className={`dialog ${styles.dialog}`}>
                    <h1 className='dialogTitle' style={{ marginBottom: '8px' }}>
                        {t('sure_delete_device')}
                    </h1>
                    <h2 className='dialogSubTitle'>
                        {device.device_type?.name} {device.model?.manufacturer?.name} {device.model?.name}
                    </h2>
                    <CancelConfirmButtons
                        onCancel={() => setShowDeleteDialog(false)}
                        onConfirm={handleDeleteDevice}
                    />
                </div>
            </Modal>
        </>
    );
};

export default DeviceStatus;